/**
 * Константы для Git-модуля: ключи localStorage, IndexedDB, значения по умолчанию.
 */
export const GIT_TOKEN_KEY = 'git_access_token';
export const GIT_URL_KEY = 'git_repo_url';
export const GIT_BRANCH_KEY = 'git_selected_branch';
export const GIT_BRANCHES_CACHE_KEY = 'git_branches_cache';
export const GIT_SELECTED_FILES_KEY = 'git_selected_files';

export const DEFAULT_REPO_URL = 'https://gitlab.globus-ltd.com/dashboard/projects';
export const STATUS_CHECK_INTERVAL_MS = 2000;
